/* eslint-disable */
import React from 'react';
import { IoMdClose } from 'react-icons/io';

import ContainedButton from 'components/layout/form/containedButton';

import {
  Content,
  Footer,
  Header,
  TitleContent,
  SubTitleContent,
} from './styles';

interface ModalConfirmDeleteAddressProps {
  onClickFail: () => void;
}

const ModalConfirmDeleteAddress: React.FC<ModalConfirmDeleteAddressProps> = ({
  onClickFail,
}) => {
  const handleClickOpenChat = (): void => {
    const chatbotButton = document?.querySelector(
      '#hi-custom-widget'
    ) as HTMLElement;
    if (chatbotButton) {
      chatbotButton?.click();
    }
  };

  return (
    <>
      <Header>
        <IoMdClose onClick={onClickFail} />
      </Header>
      <Content>
        <TitleContent>
          Não é possível remover essa empresa/condomínio.
        </TitleContent>
        <SubTitleContent>
          Caso tenha dúvidas, fale com a Ully
          <button type="button" onClick={() => handleClickOpenChat()}>
            (clique aqui)
          </button>
        </SubTitleContent>
      </Content>
      <Footer>
        <ContainedButton onClick={onClickFail}>OK!</ContainedButton>
      </Footer>
    </>
  );
};

export default ModalConfirmDeleteAddress;
